import { AxiosResponse } from "axios";
import { IGetResponse, IListResponse } from "../../../models/Api";
import { axiosInstance } from "../../../../../axiosInstance";
import {
  Checkpoint,
  CheckpointType,
  CreateCheckpointOpts,
  CreateCheckpointTypeOpts,
  CreateRoundFormOpts,
  ListCheckpointsOpts,
  ListCheckpointTypesOpts,
  ListRoundFormsOpts,
  Round,
  RoundForm,
  UpdateCheckpointOpts,
  UpdateCheckpointTypeOpts,
  UpdateRoundFormOpts,
} from "../../../models/Api/Inspection";

export const listRounds = async (
  payload: ListRoundFormsOpts
): Promise<AxiosResponse<IListResponse<Round>>> => {
  const { offset, limit, filter } = payload;

  const params = {
    offset,
    limit,
  };

  const keys = Object.keys(filter);
  keys.forEach(key => {
    const operator = Object.keys(filter[key]);
    if (operator) {
      const value = filter[key][operator];
      if (operator.includes("between")) {
        value.forEach((val: string, index: number) => {
          params[`${key}[${operator}][${index}]`] = val;
        });
      } else {
        if (value !== null && value !== "" && value !== undefined) {
          params[`${key}[${operator}]`] = value;
        }
      }
    }
  });

  return axiosInstance.get(`/inspection/rounds`, { params });
};

export const getRound = async (
  id: string
): Promise<AxiosResponse<IGetResponse<Round>>> => {
  return axiosInstance.get(`/inspection/rounds/${id}`);
};

export const listRoundForms = async (
  payload: ListRoundFormsOpts
): Promise<AxiosResponse<IListResponse<RoundForm>>> => {
  const { offset, limit, filter } = payload;

  const params = {
    offset,
    limit,
  };

  const keys = Object.keys(filter);
  keys.forEach(key => {
    const operator = Object.keys(filter[key]);
    if (operator) {
      const value = filter[key][operator];
      if (operator.includes("between")) {
        value.forEach((val: string, index: number) => {
          params[`${key}[${operator}][${index}]`] = val;
        });
      } else {
        if (value !== null && value !== "" && value !== undefined) {
          params[`${key}[${operator}]`] = value;
        }
      }
    }
  });

  return axiosInstance.get(`/inspection/round_forms`, { params });
};

export const getRoundForm = async (
  id: string
): Promise<AxiosResponse<IGetResponse<RoundForm>>> => {
  return axiosInstance.get(`/inspection/round_forms/${id}`);
};

export const createRoundForm = async (
  payload: CreateRoundFormOpts
): Promise<AxiosResponse<IGetResponse<RoundForm>>> => {
  return axiosInstance.post("/inspection/round_forms", payload);
};

export const updateRoundForm = async ({
  id,
  ...payload
}: UpdateRoundFormOpts): Promise<AxiosResponse<IGetResponse<RoundForm>>> => {
  return axiosInstance.put(`/inspection/round_forms/${id}`, payload);
};

export const deleteRoundForm = async (
  id: number
): Promise<AxiosResponse<IGetResponse<RoundForm>>> => {
  return axiosInstance.delete(`/inspection/round_forms/${id}`);
};

export const getCheckpointType = async (
  id: string
): Promise<AxiosResponse<IGetResponse<CheckpointType>>> => {
  return axiosInstance.get(`/inspection/types/${id}`);
};

export const listCheckpointTypes = async (
  payload: ListCheckpointTypesOpts
): Promise<AxiosResponse<IListResponse<CheckpointType>>> => {
  const { offset, limit, filter } = payload;

  const params = {
    offset,
    limit,
  };

  const keys = Object.keys(filter);
  keys.forEach(key => {
    const operator = Object.keys(filter[key]);
    if (operator) {
      const value = filter[key][operator];
      if (operator.includes("between")) {
        value.forEach((val: string, index: number) => {
          params[`${key}[${operator}][${index}]`] = val;
        });
      } else {
        if (value !== null && value !== "" && value !== undefined) {
          params[`${key}[${operator}]`] = value;
        }
      }
    }
  });

  return axiosInstance.get("/inspection/types", { params });
};

export const createCheckpointType = async (
  payload: CreateCheckpointTypeOpts
): Promise<AxiosResponse<IGetResponse<CheckpointType>>> => {
  return axiosInstance.post("/inspection/types", payload);
};

export const updateCheckpointType = async ({
  id,
  ...payload
}: UpdateCheckpointTypeOpts): Promise<
  AxiosResponse<IGetResponse<CheckpointType>>
> => {
  return axiosInstance.put(`/inspection/types/${id}`, payload);
};

export const deleteCheckpointType = async (
  id: number
): Promise<AxiosResponse<IGetResponse<CheckpointType>>> => {
  return axiosInstance.delete(`/inspection/types/${id}`);
};

export const getCheckpoint = async (
  checkpointTypeId: string,
  checkpointId: string
): Promise<AxiosResponse<IGetResponse<Checkpoint>>> => {
  return axiosInstance.get(
    `/inspection/types/${checkpointTypeId}/checkpoints/${checkpointId}`
  );
};

export const listCheckpoints = async ({
  checkpointTypeId,
  ...payload
}: ListCheckpointsOpts): Promise<AxiosResponse<IListResponse<Checkpoint>>> => {
  return axiosInstance.get(
    `/inspection/types/${checkpointTypeId}/checkpoints`,
    { params: payload }
  );
};

export const createCheckpoint = async (
  checkpointTypeId: string,
  payload: CreateCheckpointOpts
): Promise<AxiosResponse<IGetResponse<Checkpoint>>> => {
  return axiosInstance.post(
    `/inspection/types/${checkpointTypeId}/checkpoints`,
    payload
  );
};

export const updateCheckpoint = async (
  checkpointTypeId: string,
  checkpointId: string,
  payload: UpdateCheckpointOpts
): Promise<AxiosResponse<IGetResponse<Checkpoint>>> => {
  return axiosInstance.put(
    `/inspection/types/${checkpointTypeId}/checkpoints/${checkpointId}`,
    payload
  );
};

export const deleteCheckpoint = async (
  checkpointTypeId: string,
  checkpointId: number
): Promise<AxiosResponse<IGetResponse<Checkpoint>>> => {
  return axiosInstance.delete(
    `/inspection/types/${checkpointTypeId}/checkpoints/${checkpointId}`
  );
};
